import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Switch} from 'kpc';

var _$tmp0 = {
    'disabled': true
};
var _$tmp1 = {
    'value': true,
    'disabled': true
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Switch, _$tmp0),
        _$cc(Switch, _$tmp1)
    ], 4 /* HasNonKeyedChildren */);
};